import React from 'react';
import { useNavigate } from 'react-router-dom';
import { paymentTypeConfig, formatMoney, formatDate } from './accountingConstants';

export default function CashFlowTab({
  kasaOperations,
  kasaFilters,
  setKasaFilters
}) {
  const navigate = useNavigate();

  return (
    <div>
      {/* Filtry */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        padding: '0.75rem',
        marginBottom: '1rem',
        display: 'flex',
        gap: '0.5rem',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <select
          value={kasaFilters.typPlatnosci}
          onChange={(e) => setKasaFilters(f => ({...f, typPlatnosci: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Wszystkie typy</option>
          {Object.entries(paymentTypeConfig).map(([key, cfg]) => (
            <option key={key} value={key}>{cfg.icon} {cfg.label}</option>
          ))}
        </select>
        <input
          type="date"
          value={kasaFilters.dateFrom}
          onChange={(e) => setKasaFilters(f => ({...f, dateFrom: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>do</span>
        <input
          type="date"
          value={kasaFilters.dateTo}
          onChange={(e) => setKasaFilters(f => ({...f, dateTo: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <button
          onClick={() => setKasaFilters({ dateFrom: '', dateTo: '', typPlatnosci: '' })}
          style={{
            padding: '6px 12px',
            border: '1px solid var(--text-muted)',
            color: 'var(--text-muted)',
            fontSize: '12px'
          }}
        >
          Wyczyść
        </button>
        <button
          onClick={() => navigate('/kasa-bank')}
          style={{
            marginLeft: 'auto',
            padding: '6px 12px',
            border: '1px solid var(--info)',
            color: 'var(--info)',
            fontSize: '12px'
          }}
        >
          Otwórz Kasa/Bank {'→'}
        </button>
      </div>

      {/* Tabela operacji */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        overflow: 'hidden'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
          <thead>
            <tr style={{ backgroundColor: 'var(--bg)' }}>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Data</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Typ</th>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Opis</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Kategoria</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Sposób płatności</th>
              <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Kwota</th>
            </tr>
          </thead>
          <tbody>
            {(Array.isArray(kasaOperations) ? kasaOperations : []).map(op => {
              const isIncome = op.typ_operacji === 'KP';
              const paymentType = paymentTypeConfig[op.typ_platnosci] || { icon: '💲', label: op.typ_platnosci, color: 'var(--text-muted)' };

              return (
                <tr key={op.id} style={{ backgroundColor: isIncome ? 'var(--success-light)' : 'var(--danger-light)' }}>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)' }}>
                    {formatDate(op.data_operacji)}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <div>
                      <span style={{
                        padding: '3px 8px',
                        backgroundColor: isIncome ? 'var(--success-light)' : 'var(--danger-light)',
                        color: isIncome ? 'var(--success)' : 'var(--danger)',
                        borderRadius: '3px',
                        fontSize: '10px',
                        fontWeight: 500
                      }}>
                        {isIncome ? '📥 KP' : '📤 KW'}
                      </span>
                      {op.numer_dokumentu && (
                        <div style={{ fontSize: '9px', color: 'var(--text-muted)', marginTop: '3px' }}>
                          {op.numer_dokumentu}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)' }}>
                    <div>{op.opis || '-'}</div>
                    {op.kontrahent && (
                      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>{op.kontrahent}</div>
                    )}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <span style={{
                      padding: '2px 6px',
                      backgroundColor: 'var(--bg)',
                      borderRadius: '3px',
                      fontSize: '10px'
                    }}>
                      {op.kategoria || '-'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <span style={{
                      padding: '2px 6px',
                      backgroundColor: paymentType.color + '20',
                      color: paymentType.color,
                      borderRadius: '3px',
                      fontSize: '10px'
                    }}>
                      {paymentType.icon} {paymentType.label}
                    </span>
                  </td>
                  <td style={{
                    padding: '10px',
                    borderBottom: '1px solid var(--border)',
                    textAlign: 'right',
                    fontWeight: 600,
                    color: isIncome ? 'var(--success)' : 'var(--danger)'
                  }}>
                    {isIncome ? '+' : '-'}{formatMoney(op.kwota)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {(!Array.isArray(kasaOperations) || kasaOperations.length === 0) && (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
            Brak operacji do wyświetlenia
          </div>
        )}
      </div>
    </div>
  );
}
